import { Opacity } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import theme from "theme";
import { Col, Row } from "v2/components/base/Flex/ui";

const Stepper = ({
  isHidePageNumber = false,
  slide,
  totalSlides,
  handleSlideChange,
  ...props
}: {
  isHidePageNumber?: boolean;
  slide: number;
  totalSlides: number;
  handleSlideChange: (slide: number) => void;
} & any) => {
  const { sx, ...rest } = props;
  return (
    <Col
      sx={{
        gap: "12px",
        padding: "12px 0 16px",
        margin: "0 auto",
        ...sx,
      }}
      fullWidth
      {...rest}>
      {!isHidePageNumber && (
        <Row type="cc" fullWidth>
          <Typography variant="mobile-body-m-heavy">
            Step {slide + 1} of {totalSlides}
          </Typography>
        </Row>
      )}
      <Row type="cc" sx={{ gap: "5px" }} fullWidth>
        {[...Array(totalSlides)].map((_, pageIndex) => (
          <Row
            onClick={() => handleSlideChange(pageIndex)}
            sx={{
              backgroundColor: theme.palette.surface.light,
              flex: 1,
              height: "3px",
              opacity: slide >= pageIndex ? 1 : 0.5,
              cursor: "pointer",
              borderRadius: "7px",
              "&:hover": {
                opacity: 1,
              },
            }}
            fullWidth
          />
        ))}
      </Row>
    </Col>
  );
};

export default Stepper;
